<template>
  <b-container v-if="!$store.getters['authAdmin/hasAdminRights']">
    <b-row class="justify-content-center">
      <b-col cols="12" md="6" lg="4">
        <div class="login-form">
          <h2 class="text-center mb-4">Connexion PC Course</h2>
          <b-alert v-if="loginError" variant="danger" dismissible @dismissed="loginError = null">
            {{ loginError }}
          </b-alert>
          <b-form @submit.prevent="handleLogin">
            <b-form-group label="Nom d'utilisateur" label-for="username">
              <b-form-input id="username" v-model="loginForm.username" type="text" placeholder="Nom d'utilisateur"
                required :disabled="isLoggingIn"></b-form-input>
            </b-form-group>
            <b-form-group label="Mot de passe" label-for="password">
              <b-form-input id="password" v-model="loginForm.pass" type="password" placeholder="Mot de passe" required
                :disabled="isLoggingIn"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="primary" block :disabled="isLoggingIn" class="mt-3">
              <span v-if="isLoggingIn">Connexion en cours...</span>
              <span v-else>Se connecter</span>
            </b-button>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>


</template>

<script>
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
    SpinnerLive,

  },
  data() {
    return {

      loginForm: {
        username: "",
        pass: "",
      },
      isLoggingIn: false,
      loginError: null,
    };
  },
  methods: {


    checkAuth() {
      // Vérifie si l'utilisateur est connecté avec les droits appropriés
      if (!this.$store.state.authAdmin.isLogged) {
        return false;
      }

      // Vérifie les droits de vérificateur (pc_course, respo_medical, coordinateur)
      if (!this.$store.getters['authAdmin/hasAdminRights']) {
        // Si pas les bons droits, afficher un message d'erreur
        this.loginError = "Vous n'avez pas les droits nécessaires pour accéder à cette page.";
        this.$store.dispatch('authAdmin/logout');
        return false;
      }
      this.$router.push({ name: "Live" });
      return true;
    },
    async handleLogin() {
      this.loginError = null;
      this.isLoggingIn = true;

      try {
        const result = await this.$store.dispatch('authAdmin/login', {
          username: this.loginForm.username,
          pass: this.loginForm.pass,
        });


        if (result && result.id) {
          // Attendre que Vue ait mis à jour le store
          await this.$nextTick();
          // Vérifier les droits après connexion (admin ou vérificateur)
          if (this.$store.getters['authAdmin/hasAdminRights']) {
            this.loginForm.username = "";
            this.loginForm.pass = "";
            this.$forceUpdate();
            this.$router.push({ name: "Live" });
          } else {
            this.loginError = "Vous n'avez pas les droits nécessaires pour accéder à cette page.";
            await this.$store.dispatch('authAdmin/logout');
          }
        } else {
          this.loginError = "Nom d'utilisateur ou mot de passe incorrect.";
        }
      } catch (error) {
        this.loginError = "Une erreur est survenue lors de la connexion. Veuillez réessayer.";
        console.error("Erreur de connexion:", error);
      } finally {
        this.isLoggingIn = false;
      }
    },
  },
  created() {
    this.checkAuth();
  },
};
</script>

<style lang="sass">
.login-container
  min-height: 70vh
  display: flex
  align-items: center
  padding-top: 2rem
  padding-bottom: 2rem

.login-form
  background: white
  padding: 2rem
  border-radius: 0.8rem
  box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px
  border: 1px solid #e0e0e0

  h2
    color: var(--primary-color, #f29200)
    font-weight: 600
</style>